import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
export var useBreakpoint = function (breakpoint) {
  var theme = useTheme();
  return useMediaQuery(theme.breakpoints.only(breakpoint));
};
export var useMobileBreakpoint = function () {
  return useBreakpoint('sm');
};